import React, { Component } from "react";
import classnames from "classnames";

import { SoftCheck } from "../../common/SoftCheck";
import * as styles from "./DeviceCheck.scss";

export interface IDeviceCheckProps {
    checked: boolean;
    ambiguous?: boolean;
    visible: boolean;
    className?: string;
    onToggle: () => void;
}

export class DeviceCheck extends Component<IDeviceCheckProps> {
    public render() {
        const { checked, ambiguous, visible, className, onToggle } = this.props;
        return (
            <div
                className={classnames(
                    styles["device-check"],
                    className,
                    visible && styles.visible,
                )}
            >
                <div>
                    <SoftCheck
                        checked={checked}
                        ambiguous={ambiguous}
                        onToggle={onToggle}
                    />
                </div>
            </div>
        );
    }
}
